import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CompanyState } from '../reducers/company.reducer';
import { StateProperty } from '../reducers';
import { Company } from '@models/company.model';

export const companiesSelector = createFeatureSelector<CompanyState>(StateProperty.COMPANIES);

export const selectCompanies = createSelector(
  companiesSelector,
  state => state.companies
);

export const selectSelectedCompanyId = createSelector(
  companiesSelector,
  state => state.selectedCompanyId
);

export const selectSelectedCompany = createSelector(
  selectCompanies,
  selectSelectedCompanyId,
  (companies, selectedId) => companies.find(c => c.id === selectedId)
);

export const selectCompanyIsLoading = createSelector(
  companiesSelector,
  state => state.isLoading
);

export const selectCompany = (id: string) => createSelector(
  companiesSelector,
  (state: CompanyState) => state.companies.find((company: Company) => company.id === id)
);

